import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Button, Icon, Text } from '@components/base'
import { useDispatchAsync } from '@src/utils'
import { UiStateNames } from '@src/types'
import { AppStackParamList, OnboardingStackParamsList } from '@src/navigation/types'
import {
  useGetThirdPartyAppName,
  useShouldShowByosOnboarding,
  useSyncsGlucoseViaAppleOrGoogle,
} from './hooks'

export const ConnectionSuccessfulScreen = () => {
  const styles = useStyleSheet(themedStyles)
  const dispatchAsync = useDispatchAsync()
  const isOnboarding = useShouldShowByosOnboarding()
  const navigation = useNavigation<
    StackNavigationProp<AppStackParamList & OnboardingStackParamsList>
  >()

  const appName = useGetThirdPartyAppName()
  const syncsGlucoseViaAppleOrGoogle = useSyncsGlucoseViaAppleOrGoogle()

  const message = syncsGlucoseViaAppleOrGoogle
    ? `You're all set. You'll begin to see glucose data in a few minutes. ` +
      `Note, there is a 3 hour delay between the ${appName} app and Nutrisense.`
    : "You've been connected successfully!"

  const onNextPress = async () => {
    if (!isOnboarding) {
      navigation.replace('Drawer', { screen: 'Dashboard' })
      return
    }

    await dispatchAsync({
      type: 'app/upsertUiState',
      payload: {
        name: UiStateNames.OwnSensorOnboardingCompleted,
        value: true,
      },
    })
  }

  return (
    <SafeAreaView edges={['top', 'bottom']} style={[styles.container]}>
      <View style={styles.contentContainer}>
        <Icon weight="fill" style={styles.icon} name="seal-check" size={48} />
        <Text type="title-2" style={{ marginTop: 16 }}>
          Done 🎉
        </Text>

        <Text type="large" style={{ paddingHorizontal: 32, marginTop: 40, textAlign: 'center' }}>
          {message}
        </Text>
      </View>

      <View style={styles.button}>
        <Button type="primary" size="block" onPress={onNextPress} accessibilityLabel="Continue">
          Continue
        </Button>
      </View>
    </SafeAreaView>
  )
}

const themedStyles = StyleService.create({
  icon: {
    marginTop: 40,
    color: 'theme.success.base',
  },
  container: {
    flex: 1,
    paddingVertical: 16,
    backgroundColor: 'theme.background',
  },
  contentContainer: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingBottom: 16,
    backgroundColor: 'theme.background',
  },
  button: {
    marginHorizontal: 24,
  },
})
